import { h, Component, ComponentChildren, ComponentType, RenderableProps } from 'preact'
import { Message } from '../../../../lib/intl/Message'
import heltUenig from './meninger-helt-uenig.svg'

import s from './SectionErrorBoundary.module.css'
import { useCustomContext } from '../../../../lib/context'

type Props = {
  children: ComponentChildren
}

type State = {
  hasError: boolean
}

export class SectionErrorBoundary extends Component<Props, State> {
  constructor() {
    super()
    this.state = { hasError: false }
  }

  render() {
    if (this.state.hasError) {
      return (
        <section class={s.sectionErrorBoundary}>
          <img src={heltUenig} alt="" />
          <h3>
            <Message id="feilmelding-seksjon-tittel" />
          </h3>
          <p>
            <Message id="feilmelding-seksjon-tekst" />
          </p>
        </section>
      )
    }
    return this.props.children
  }

  componentDidCatch(error: any) {
    const { sendError } = useCustomContext()
    sendError(error)
    this.setState({ hasError: true })
  }
}

export function withSectionErrorBoundary<P = {}>(Component: ComponentType<P>) {
  return (props: RenderableProps<P>) => {
    return (
      <SectionErrorBoundary>
        <Component {...props} />
      </SectionErrorBoundary>
    )
  }
}
